import message from "@/plugins/message";
import { useCountDown } from "ahooks";
import { useState } from "react";
import styled from "styled-components";

const Box = styled.div`
  color: #fff;
  background: rgba(0, 0, 0, 0.2);
  padding: 5px 6px;
  font-size: 12px;
  line-height: 18px;
  font-weight: 500;
  cursor: pointer;
`;
const SMSCodeBtn = ({
  phone,
}: {
  phone: string;
}) => {
  const [sended, setSended] = useState(false);
  const [targetDate, setTargetDate] = useState<number>();
  const [loading, setLoading] = useState(false);

  const [countdown] = useCountDown({
    targetDate,
  });
  const sendSmsCode = async () => {
    if (loading || countdown) return;
    setLoading(true); 
        // 判断环境
        const isProd = process.env.PROJECT_ENV === "prod";
      const res = await fetch(
        `https://aibeings-staff${isProd ? "" : "-int"}.xiaoice.com/api/info/code?phone=${phone}`
      );
    setLoading(false);
    if (!res.ok) {
      message.warning("发送验证码失败，请稍后再试");
      return;
    }
    const data = await res.json();
    if (data.code !== 200) {
      message.warning(data.message || "发送验证码失败，请稍后再试");
      return;
    }
    message.success("验证码已发送，请查收短信");
    setTargetDate(Date.now() + 60000);
    setSended(true);
  };
  return (
    <Box onClick={() => sendSmsCode()} style={{
        background: countdown ? "transparent" : "rgba(0, 0, 0, 0.2)",
    }}>
      {countdown
        ? `${Math.round(countdown / 1000)}s`
        : sended
        ? "重新发送"
        : "发送验证码"}
    </Box>
  );
};

export default SMSCodeBtn;
